import { createStore } from 'redux';
import packageReducer from '../reducers/package_reducer';

const store = createStore(packageReducer);

export default store;
